import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import PageHero from "../components/PageHero";
import Seo from "../components/Seo";
import { Reveal } from "../components/Reveal";
import api from "../lib/api";

export default function FreePage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPage(null);
    setNotFound(false);
    api.page(slug).then(setPage).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="mx-auto max-w-3xl px-5 pt-40 pb-28 text-center">
        <h1 className="font-serif text-4xl text-white">Page introuvable</h1>
        <Link to="/" className="mt-6 inline-flex items-center gap-2 text-gold hover:underline">
          <ArrowLeft className="h-4 w-4" /> Retour à l'accueil
        </Link>
      </div>
    );
  }
  if (!page) return <div className="pt-40 pb-28 text-center text-slate-500">Chargement…</div>;

  return (
    <div data-testid="free-page">
      <Seo title={page.title} path={`/p/${page.slug}`} description={(page.body || "").slice(0, 150)} />
      <PageHero title={[page.title]} subtitle="" image={page.image || undefined} testid="free-page-hero" />
      <section className="relative z-10 mx-auto max-w-3xl px-5 pb-28 lg:px-8">
        <Reveal className="space-y-5">
          {(page.body || "").split("\n").filter((p) => p.trim()).map((p, i) => (
            <p key={i} className="text-lg leading-relaxed text-slate-300">{p}</p>
          ))}
        </Reveal>
      </section>
    </div>
  );
}
